module.exports = __webpack_public_path__ + "img/fullscreen.ef646924.svg";